export const columnsPanelSx = {
  width: '320px',
  '& .MuiDataGrid-panelHeader, & .MuiDataGrid-panelFooter': {
    padding: '16px',
  },
  '& .MuiDataGrid-panelContent': {
    padding: '0 16px 16px 16px',
    borderTop: '1px solid rgba(0, 0, 0, 0.05)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
  },
};

export const reportSx = {
  backgroundColor: 'white',
  borderRadius: '8px',
  boxShadow: '0px 1px 20px 0px rgba(0, 0, 0, 0.05)',
  '& .MuiDataGrid-pinnedColumns, & .MuiDataGrid-pinnedColumnHeaders': {
    backgroundColor: 'white',
  },
  '& .MuiDataGrid-footerContainer': {
    flexDirection: 'column',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    color: 'rgba(38, 50, 56, 0.54)',
    fontWeight: 'regular',
  },
  '& .MuiDataGrid-cell': {
    borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
    padding: '0 16px',
  },
  '& .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  '& .MuiDataGrid-columnHeader': {
    borderBottom: '1px solid rgb(224, 224, 224)',
    borderTop: '1px solid rgb(224, 224, 224)',
    padding: '0 16px',
  },
  '& .MuiDataGrid-pinnedColumnHeaders .MuiDataGrid-columnHeader': {
    borderBottom: '2px solid rgba(0, 0, 0, 0.05)',
  },
  '& .MuiDataGrid-row:hover, & .MuiDataGrid-row.Mui-hovered': {
    bgcolor: 'rgba(244, 243, 255, 0.25)',
    cursor: 'pointer',
  },
  '& .MuiDataGrid-pinnedRows': {
    backgroundColor: '#f5f5f5',
    fontWeight: 'bold',
    borderTop: '2px solid rgba(0, 0, 0, 0.12)',
  },
  '& .MuiDataGrid-pinnedRows .MuiDataGrid-row:hover': {
    backgroundColor: '#f5f5f5',
    cursor: 'default',
  },
};
